import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-[14px] font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0071e3]/40 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:     "bg-[#0071e3] text-white hover:bg-[#0077ed] active:bg-[#006edb] rounded-[980px]",
        destructive: "bg-destructive text-white hover:bg-destructive/90 rounded-[980px]",
        outline:     "border border-[#d2d2d7] bg-white text-[#1d1d1f] hover:bg-[#f5f5f7] rounded-[980px]",
        secondary:   "bg-[#f5f5f7] text-[#1d1d1f] hover:bg-[#e8e8ed] rounded-[980px]",
        ghost:       "text-[#1d1d1f] hover:bg-[#f5f5f7] rounded-xl",
        link:        "text-[#0071e3] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-[36px] px-5 py-2",
        sm:      "h-[32px] px-4 text-[13px]",
        lg:      "h-[44px] px-8 text-[16px]",
        icon:    "h-10 w-10 rounded-full",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Button.displayName = "Button";

export { Button, buttonVariants };
